import React from 'react';
import { useInView } from 'react-intersection-observer';
import { ExternalLink } from 'lucide-react';
import { useSectionData } from '../hooks/useSectionData';
import { fetchResearch, attr } from '../services/api';

export default function Research() {
  const items = useSectionData(fetchResearch);
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });

  if (!items) return null;

  return (
    <section id="research" ref={ref} className={`section${inView ? ' visible' : ''}`}>
      <div className="container">
        <header className="section-header">
          <p className="section-label">research</p>
          <h2 className="section-title">Research Papers</h2>
          <div className="section-line" />
        </header>

        <div className="research-list">
          {items.map((item, i) => {
            const a = attr(item);
            return (
              <div key={i} className="research-item">
                <h3 className="research-title">{a.title}</h3>
                <div className="research-meta">
                  {a.authors && <span>{a.authors}</span>}
                  {a.publication && <span>· {a.publication}</span>}
                  {a.year && <span>· {a.year}</span>}
                </div>
                {a.abstract && (
                  <p className="research-abstract">{a.abstract}</p>
                )}
                <div style={{ display: 'flex', gap: 16, marginTop: 10 }}>
                  {a.url && (
                    <a href={a.url} target="_blank" rel="noreferrer noopener" className="research-link">
                      <ExternalLink size={13} /> Read Paper
                    </a>
                  )}
                  {a.doi && (
                    <a
                      href={`https://doi.org/${a.doi}`}
                      target="_blank"
                      rel="noreferrer noopener"
                      className="research-link"
                    >
                      <ExternalLink size={13} /> DOI
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
